"use client"

import { BluetoothConnected } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BluetoothConnectedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BluetoothConnectedIcon = component(Icon)({
  as: BluetoothConnected,
})
